export default __webpack_public_path__ + "static/node_runner_mobile-c9839a2143717dd3bf941bef48a07f65.png";